import {wxUserInfo} from "network/login.js"
import store from "../store"
export function getWxUserInfo(callBack){
    wxUserInfo().then(res=>{
        if(res.code == 1){
            store.dispatch('getChangLoginState',true)
        }else{
            store.dispatch('getChangLoginState',false)
        }
        callBack()
    })
}
